import Icon from '../components/Icon.vue'

Icon.register({
  hryvnia: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M368 240h-99.7l-34.7 32h134.4c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-203.7l-29.5 27.2c-4.3 4-6.8 9.7-6.8 15.6 0 11.7 9.5 21.2 21.2 21.2h83.6 0c4.8 0 11.7-2.5 15.4-5.6l11.8-9.8c10.2-8.5 25.3-7.1 33.8 3.1l20.5 24.6c8.5 10.2 7.1 25.3-3.1 33.8l-11.8 9.8c-18.7 15.6-42.2 24.1-66.5 24.1h-78.8c-37.1 0-73.4-17.8-92-50-17.9-30.7-17.5-65.4-4.1-94h-41.9c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h99.7l34.7-32h-134.4c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h203.7l29.5-27.2c4.3-4 6.8-9.7 6.8-15.6 0-11.7-9.5-21.2-21.2-21.2h-83.6c-5.6 0-11.1 2-15.4 5.6l-11.7 9.8c-10.2 8.5-25.3 7.1-33.8-3.1l-20.5-24.6c-8.5-10.2-7.1-25.3 3.1-33.8l11.8-9.8c18.7-15.6 42.2-24.1 66.5-24.1h78.8c37.1 0 73.4 17.8 92 50 17.9 30.7 17.5 65.4 4.1 94h41.9c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hryvnia.js
// module id = 1476
// module chunks = 0